import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from '../../core/client';
import type { ActivityEntry, KpiSnapshot, SeriesDay } from './analytics.types';

const ANALYTICS = '/users/v1/analytics';
const KEY = ['analytics'] as const;

export function useKpiSnapshot() {
  return useQuery({
    queryKey: [...KEY, 'kpi'],
    queryFn: () => api.get<KpiSnapshot>(`${ANALYTICS}/kpi`),
    refetchInterval: 30_000,
  });
}

export function useEventSeries(from: number, to: number) {
  return useQuery({
    queryKey: [...KEY, 'series', from, to],
    queryFn: () => api.get<SeriesDay[]>(`${ANALYTICS}/series?from=${from}&to=${to}`),
    refetchInterval: 60_000,
    // A period change is a new key — hold the previous period on screen (the page
    // marks it as refreshing) instead of dropping back to a first-load state.
    placeholderData: keepPreviousData,
  });
}

export function useActivityTimeline(from: number, to: number, limit = 100) {
  return useQuery({
    queryKey: [...KEY, 'timeline', from, to, limit],
    queryFn: () => api.get<ActivityEntry[]>(`${ANALYTICS}/timeline?from=${from}&to=${to}&limit=${limit}`),
    refetchInterval: 60_000,
    placeholderData: keepPreviousData,
  });
}
